import type { CellContext } from "@tanstack/react-table";

export const CountCell = ({ cell }: CellContext<any, unknown>) => {
  const { row } = cell;

  return <div>{row.original.count}</div>;
};
